import React from 'react'
import { createUseStyles } from 'react-jss'
import { Link } from 'react-router-dom'
import { ChevronRight } from '../../../assets/icons'
import { colors } from '../../../theme/palette'
import breakpoints from '../../../theme/breakpoints'

interface BackLinkInterface {
    to: string
    label: string
}

const useStyles = createUseStyles(() => ({
    BackLink: {
        padding: '10px 0',
        display: 'flex',
        fontSize: '0.875rem',
        color: colors.black,
        fontWeight: '700',
        '&:hover': {
            color: colors.labelColor,
            '& svg': {
                color: colors.labelColor,
            },
        },
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            fontSize: '1.125rem',
        },
    },
    span: {
        display: 'block',
        marginLeft: '12px',
    },
}))

const BackLink: React.FC<BackLinkInterface> = ({ to, label }) => {
    const classes = useStyles()

    return (
        <Link to={to} className={classes.BackLink}>
            <ChevronRight color={colors.black} width="8px" />
            <span className={classes.span}>{label}</span>
        </Link>
    )
}

export { BackLink }
